import { render } from "./TNavComponent.vue?vue&type=template&id=2d153616"
import script from "./TNavComponent.vue?vue&type=script&lang=js"
export * from "./TNavComponent.vue?vue&type=script&lang=js"

import exportComponent from "D:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__